// extracted by mini-css-extract-plugin
export default {"container":"UT-z","title":"VT-z","link":"WT-z"};